import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'budgetRange'

const OPTIONS = [
  {
    value: 'Low budget',
    translationKey: 'pages.onboarding.budgetRange.options.low',
    subtextKey: 'pages.onboarding.budgetRange.subtexts.low',
    emoji: '💸',
  },
  {
    value: 'Mid-range',
    translationKey: 'pages.onboarding.budgetRange.options.mid',
    subtextKey: 'pages.onboarding.budgetRange.subtexts.mid',
    emoji: '💳',
  },
  {
    value: 'Premium',
    translationKey: 'pages.onboarding.budgetRange.options.premium',
    subtextKey: 'pages.onboarding.budgetRange.subtexts.premium',
    emoji: '✨',
  },
  {
    value: 'Not important',
    translationKey: 'pages.onboarding.budgetRange.options.notImportant',
    subtextKey: 'pages.onboarding.budgetRange.subtexts.notImportant',
    emoji: '🤷',
  },
]

export default function BudgetRangePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    // Find the selected option to get both value and subtext
    const selectedOption = OPTIONS.find((option) => option.value === value)
    const subtext = selectedOption ? t(selectedOption.subtextKey) : ''

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you have a budget range in mind?',
      answer_key: value,
      answer: `${value} - ${subtext}`,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.budgetRange.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
